// Footer language picker. On English URLs it only changes the visitor's
// saved language (the jm_lang cookie): the page itself stays at its URL and
// the UI around it switches. /es and /pt pages are in their language because
// of the URL, so picking another one goes to that language's home - this
// component doesn't know the page's alternates (LanguageSuggest does).
import React from "react";
import { useRouter } from "next/router";
import { Globe } from "lucide-react";
import {
  LOCALES,
  useLocale,
  useT,
  type Locale,
} from "@jammable/ui-core/src/i18n";

// Each language named in itself, so it is findable whatever the UI is in.
const NAMES: Record<Locale, string> = {
  en: "English",
  es: "Español",
  pt: "Português",
};

export default function LanguageSwitcher() {
  const t = useT();
  const router = useRouter();
  const { locale, fromUrl, setLocale } = useLocale();

  const choose = (l: Locale) => {
    if (l === locale) return;
    setLocale(l);
    if (fromUrl) router.push(l === "en" ? "/" : `/${l}`);
  };

  return (
    <label className="tw-inline-flex tw-items-center tw-gap-2 tw-self-start tw-rounded-full tw-bg-white tw-px-4 tw-py-2 tw-text-[13px] tw-font-extrabold tw-text-jam-ink focus-within:tw-ring-2 focus-within:tw-ring-jam-purple">
      <Globe size={16} strokeWidth={2.5} aria-hidden="true" />
      <span className="tw-sr-only">{t("nav.language")}</span>
      <select
        value={locale}
        onChange={(e) => choose(e.target.value as Locale)}
        className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-[13px] tw-font-extrabold tw-text-jam-ink tw-outline-none"
      >
        {LOCALES.map((l) => (
          <option key={l} value={l} lang={l}>
            {NAMES[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
